import React from 'react'
import { withNamespaces } from 'react-i18next'
import { Link } from 'gatsby'

const HeaderAvalingua = ({ t }) => (
  <header id="header">
    <div className="language-switcher">
      <ul>
        <li>
          <Link to="/info">en</Link>
        </li>
        <li>
          <Link to="/gl/info">gl</Link>
        </li>
        <li>
          <Link to="/es/info">es</Link>
        </li>
        <li>
          <Link to="/pt/info">pt</Link>
        </li>
      </ul>
    </div>
    <h1>Avalingua</h1>
    <p>{t('What is Avalingua?')}</p>
  </header>
)

export default withNamespaces()(HeaderAvalingua)
